import styled from 'styled-components';
// import iconStep from '../../../../images/login/icon_step.png';

interface IProps {
  step: number;
  depth?: number;
  direction?: 'row' | 'column';
}
interface INumber {
  selected: boolean;
}

const StepSmallWrap = styled.div<{ direction: IProps['direction']; depth: number }>`
  width: ${({ depth }) => `${depth * 6.25}rem`};
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    right: 0;
    width: ${({ depth }) => `${depth * 50}px`};

    top: ${({ direction }) => (direction === 'row' ? -30 : 0)}px;
  }

  > img {
    height: 1.2rem;
  }
`;

const Number = styled.span<INumber>`
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: white;
  font-size: 0.8rem;
  background-color: ${(props) => (props.selected ? '#333' : '#ccc')};
  border-radius: 50%;
`;

function StepSmall({ step, direction, depth = 3 }: IProps) {
  const renderSteps = () => {
    const steps = [];
    for (let i = 1; i <= depth; i++) {
      steps.push(
        <Number key={i} selected={step === i}>
          {i.toString().padStart(2, '0')}
        </Number>,
      );

      if (i < depth) {
        steps.push(<img key={`arrow-${i}`} src="/images/iconStep.png" alt="step" />);
      }
    }
    return steps;
  };

  return (
    <StepSmallWrap direction={direction} depth={depth}>
      {renderSteps()}
    </StepSmallWrap>
  );
}

export default StepSmall;
